import { Stepper, type StepperItem } from "@dionatanbig2be/big2be-ui";
import { PROGRESS_STEPS } from "../../lib/orders.config";
import type { OrderProgressStep } from "../../types/orders";

/**
 * Trilha de progresso do pedido. `step` é a etapa atual; etapas anteriores
 * ficam preenchidas. Pedido concluído usa a paleta de sucesso; `error` marca
 * a etapa atual como falha (ex.: pagamento recusado).
 */
export function OrderProgressStepper({ step, error = false }: { step: OrderProgressStep; error?: boolean }) {
    const activeIdx = PROGRESS_STEPS.findIndex((s) => s.key === step);
    const allDone = step === "concluido";

    const steps: StepperItem[] = PROGRESS_STEPS.map((s, idx) => ({
        label: <span className="whitespace-pre-line leading-tight">{s.label}</span>,
        icon: <s.Icon size={14} aria-hidden="true" />,
        ...(allDone && idx === activeIdx ? { state: "completed" as const } : {}),
        ...(error && idx === activeIdx ? { state: "error" as const } : {}),
    }));

    return (
        <div aria-label="Progresso do pedido" className="px-2 pb-1 pt-3">
            <Stepper
                steps={steps}
                currentStep={activeIdx}
                color={allDone ? "success" : "primary"}
                orientation="horizontal"
            />
        </div>
    );
}
